module.exports = __webpack_public_path__ + "img/moblie.502239ef.jpg";